import { Fragment } from 'react';
import GameSliderNavButton from './SliderNavButton';
import '../index.css';

export function StockBar({
  name,
  packsInStore,
  games,
  currentGame,
  onSelect,
  onSelectButton,
}) {
  return (
    <div className="relative flex flex-col items-center justify-center">
      {/* gradient bar */}
      <div className="text-blue to-zinc-0 -pb-1 absolute inset-x-0 bottom-0 z-10 mx-auto flex flex-col items-center justify-center bg-bottom bg-no-repeat pb-4">
        {/* game navigation buttons */}
        <span className="flex w-full items-center justify-center">
          <span className="flex h-6 items-center justify-center gap-0 rounded-4xl bg-black/25 px-0.5 py-3.5 backdrop-blur-xs">
            {games.map((game, index) => (
              <Fragment key={game.id}>
                <GameSliderNavButton
                  game={game}
                  onClick={() => onSelect(index)}
                  active={currentGame === index}
                />
              </Fragment>
            ))}
          </span>
        </span>
      </div>
    </div>
  );
}

export default StockBar;
